exports.history_type_names = {
    REQUEST: 'Request',
    MEMO: 'Memo',
    RETURN: 'Pending Return',
    RETURN_MEMO: 'Returned',
    SOLD: 'Sold',
    INVOICE: 'Invoiced',
    CREDIT: 'Returned'
}